/** Startseite von KMVS — das Dashboard. */
const STARTSEITE = "/";

/**
 * „Zurück in KMVS“ (User 27.10.2026: „nicht nochmal zurück ins erste Fenster,
 * sondern im neuen Fenster KMVS öffnen, dann einfach Dashboard“): Das
 * Browserfenster geht nicht zu, sondern wird selbst zu KMVS. So steht auf dem
 * zweiten Bildschirm danach ein vollwertiges KMVS.
 *
 * Es ist dann ein eigenständiges KMVS — ohne Fensternamen (sonst öffnete der
 * Knopf „Als eigenes Browserfenster öffnen“ dasselbe Fenster später genau hier
 * hinein und überschriebe es) und ohne Verweis aufs Hauptfenster (die PDF-Seite
 * hielte sich sonst für einen Neben-Tab und schlösse sich selbst).
 */
export function zeigeKmvs(popup: Window) {
  try {
    popup.name = "";
    popup.opener = null;
    popup.location.replace(new URL(STARTSEITE, window.location.origin).href);
  } catch {
    popup.close();
  }
}
